import axios from 'axios';

// search payment terms api
export async function searchPaymentTermAPI(Data) {
	let paymentTermlist = [];
	const TermVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentTerms/search/?termName=${TermVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		paymentTermlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return paymentTermlist;
}

//list payment terms api
export async function listPaymentTermAPI() {
	let paymentTermData = [];
	try{
		const axiosResponse = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentTerms/`,
			// data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		paymentTermData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return paymentTermData;
}

// search payment terms api
export async function getPaymentTermNameAPI(Data) {
	let paymentTermlist = [];
	const TermName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentTerms/getTerm/?termName=${TermName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		paymentTermlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return paymentTermlist;
}

//create payment terms api
export async function createPaymentTermAPI(Data, userID) {
	let paymentTermData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentTerms/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		paymentTermData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return paymentTermData;
}

//update payment term api
export async function updatePaymentTermsAPI(Data, termID, userID) {
	let agentData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentTerms/update/?termID=${termID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		agentData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return agentData;
}